import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = {
    copyUrlBase: String,
    blankMsg: String,
  };

  static targets = ['step1', 'step2'];

  showStep2() {
    this.step1Target.classList.add('hidden');
    this.step2Target.classList.remove('hidden');
  }

  submitCopy(event) {
    event.preventDefault();

    const form = this.element;
    const select = form.querySelector('select');

    const selectedId = select.value?.trim();

    if (!selectedId) {
      alert(this.blankMsgValue || 'Please select one');
      return;
    }

    const url = this.copyUrlBaseValue.replace(':id', selectedId);
    window.location.href = url;
  }
}
